import { useHistory } from 'react-router'
import React, { useCallback } from 'react'
import styled from 'styled-components'

import { BackendJob } from 'components/EditJob'
import { useActionApi } from 'hooks'
import Api from 'api'

import FixedLoader from 'components/FixedLoader'
import FixedError from 'components/FixedError'
import Feedback from 'components/Feedback'

const PageWrapper = styled.div`
	width: 100%;
	max-width: 100%;
	background-color: #fff;
	overflow: auto;
	position: relative;
	min-height: 100vh;
`;

export default function JobPostFeedbackPage() {
	const history = useHistory()

	const [deleteLoading, deleteError, deleteJobPosting] = useActionApi({
		apiMethod: Api.deleteJobPosting,
		onSuccess: useCallback(() => {
			history.replace('deleteSuccess')
		}, [history])
	})

	// job to delete
	const { job }: { job: BackendJob } = history.location.state as any

	return (
		<PageWrapper>
			<Feedback
				onClose={
					useCallback(() => {
						history.goBack()
					}, [history])
				}
				onSubmit={useCallback(() => {
					deleteJobPosting(job.id as number)
				}, [deleteJobPosting, job.id])}
			/>
			<FixedLoader
				loading={deleteLoading}
			/>
			<FixedError
				error={deleteError}
			/>
		</PageWrapper>
	)
}
